import { axios, Response } from '../index'

export interface MacroArea {
  id: string
  macroAreaName: string
  macroAreaIdentifier: string
  macroAreaBodyView: string
  posX: number
  posY: number
  bodyPointsResponses: BodyPoint[]
}

export interface BodyPoint {
  id?: string
  name: string
  posX: number
  posY: number
}

const getMacroAreas = (): Response<MacroArea[]> => {
  return axios.get(`/v1/macro-areas`)
}

export default getMacroAreas
